module.exports = __webpack_public_path__ + "img/icon-scan-failed-underpaid-en.40ec9d39.svg";